import React from 'react';

/* Icon set ported verbatim from the uploaded Divispend prototype (dashboard-client.tsx). */
const PATHS = {
  overview: <><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10.5V20h13v-9.5M9 20v-6h6v6"/></>,
  money: <><rect x="3" y="6" width="18" height="13" rx="3"/><path d="M16 10h5v5h-5a2.5 2.5 0 0 1 0-5Z"/><path d="M7 6V4h10v2"/></>,
  spend: <><path d="M12 3v18M16.5 7H9.8a3 3 0 0 0 0 6h4.4a3 3 0 0 1 0 6H7"/></>,
  transactions: <><path d="m7 7-4 4 4 4M3 11h13M17 17l4-4-4-4M21 13H8"/></>,
  reports: <><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></>,
  receipt: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z"/><path d="M9 8h6M9 12h6"/></>,
  sales: <><path d="M4 9h16l-1 11H5L4 9Z"/><path d="M8 9a4 4 0 0 1 8 0"/></>,
  invoice: <><path d="M6 3h9l4 4v14H6V3Z"/><path d="M14 3v5h5M9 13h6M9 17h4"/></>,
  contacts: <><circle cx="9" cy="8" r="3"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0M16 6.5a3 3 0 0 1 0 5.5M17 15a5 5 0 0 1 3.5 5"/></>,
  mileage: <><path d="M4 18V9l3-5h10l3 5v9"/><path d="M4 14h16M7 18v2M17 18v2"/><circle cx="7.5" cy="11" r="1"/><circle cx="16.5" cy="11" r="1"/></>,
  funding: <><path d="M3 21h18M5 18h14M6 8v10M10 8v10M14 8v10M18 8v10M3 8h18L12 3 3 8Z"/></>,
  connections: <><circle cx="7" cy="12" r="3"/><circle cx="17" cy="6" r="3"/><circle cx="17" cy="18" r="3"/><path d="m9.7 10.6 4.6-3.2M9.7 13.4l4.6 3.2"/></>,
  team: <><circle cx="8" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M2.5 20a5.5 5.5 0 0 1 11 0M13 20a4 4 0 0 1 8 0"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1a1.7 1.7 0 0 0 1.9.3A1.7 1.7 0 0 0 10 3V2.8h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1Z"/></>,
  search: <><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></>,
  bell: <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4"/></>,
  sun: <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></>,
  moon: <path d="M21 13a8 8 0 1 1-10-10 7 7 0 0 0 10 10Z"/>,
  eye: <><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"/><circle cx="12" cy="12" r="2.5"/></>,
  plus: <path d="M12 5v14M5 12h14"/>,
  camera: <><path d="M4 7h4l1.5-2h5L16 7h4v12H4V7Z"/><circle cx="12" cy="13" r="3.5"/></>,
  drive: <><path d="M5 18 4 9l3-4h10l3 4-1 9H5Z"/><path d="M4 12h16M8 18v2M16 18v2"/></>,
  chevron: <path d="m9 18 6-6-6-6"/>,
  spark: <><path d="m12 3 1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3Z"/><path d="m19 15 .8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z"/></>,
  shield: <><path d="M12 3 20 6v5c0 5-3.4 8.2-8 10-4.6-1.8-8-5-8-10V6l8-3Z"/><path d="m8.5 12 2.2 2.2 4.8-5"/></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M8 3v4M16 3v4M3 10h18"/></>,
  more: <><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></>,
};

export function Icon({ name, size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS[name] || null}
    </svg>
  );
}

export const navGroups = [
  { label: "Workspace", items: [
    { name: "Overview", icon: "overview" }, { name: "Money", icon: "money" },
    { name: "Spend", icon: "spend", badge: "4" }, { name: "Transactions", icon: "transactions" },
    { name: "Reports", icon: "reports" },
  ]},
  { label: "Operate", items: [
    { name: "Receipts", icon: "receipt", badge: "7" }, { name: "Sales", icon: "sales" },
    { name: "Invoices", icon: "invoice", badge: "3" }, { name: "Contacts", icon: "contacts" },
    { name: "Mileage", icon: "mileage" }, { name: "Funding", icon: "funding" },
  ]},
  { label: "Manage", items: [
    { name: "Connections", icon: "connections" }, { name: "Team", icon: "team" },
    { name: "Settings", icon: "settings" },
  ]},
];

export function navHref(name) {
  if (name === "Overview") return "/workspace";
  return `/app/${name.toLowerCase().replaceAll(" ", "-")}`;
}
